import { Post } from "../utils/http.js"

export function getOnlineStoreTags(query) {
  return Post("/api/terns/storeTags", query)
}

export function getStoreRegions(params) {
  return Post("/api/terns/storeRegions", params)
}
export function getClickCollectStores(params) {
  return Post("/api/terns/storesByRegion", params)
}

export function getInitPickUp(params) {
  return Post("/api/terns/initPickUp", params, {
    loading: true
  })
}
